<img class="brand" src="/assets/logo-branded-white.png" />
<span class="clinic tk-proxima-nova-wide">Springhill Medical Center</span>
<sv-toolbar-time></sv-toolbar-time>
